import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Button, TextArea } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { getPhrasesCount, replaceDividerSymbols } from '../../../service/PhrasesSelectorWizard/PhrasesSelectorWizard';
import { TestBem } from '../../../service/TestBem';
import { PhrasesSelectorGeneratorGroupPhrases } from '../../../typings/phrases';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';

import './PhrasesSelectorGeneratorGroup.css';
import * as keyset from './PhrasesSelectorGeneratorGroup.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'phrases-selector-generator-group';

export interface PhrasesSelectorGeneratorGroupProps {
    canRemoveGroup: boolean;
    index: number;
    phrases: PhrasesSelectorGeneratorGroupPhrases;
    onGroupRemove: (index: number) => void;
    onPhrasesChange: (index: number, phrases: PhrasesSelectorGeneratorGroupPhrases) => void;
}

export class PhrasesSelectorGeneratorGroup extends React.PureComponent<PhrasesSelectorGeneratorGroupProps> {
    render() {
        const { canRemoveGroup, phrases, index } = this.props;

        return (
            <div className={classNames(Bem.cls(BLOCK), TestBem.cls(BLOCK))}>
                <TextArea
                    text={phrases}
                    theme="normal"
                    size="s"
                    rows={8}
                    placeholder={i18n('phrases-placeholder')}
                    cls={classNames(
                        Bem.cls(BLOCK, 'phrases-textarea'),
                        TestBem.cls(BLOCK, 'phrases-textarea', { index: String(index) })
                    )}
                    onChange={this.onPhrasesChange}
                    onBlur={this.onBlur}
                />
                <div className={Bem.cls(BLOCK, 'footer')}>
                    {i18n('phrases-caption', {
                        count: getPhrasesCount(phrases)
                    })}
                    {canRemoveGroup && (
                        <Button
                            cls={classNames(
                                Bem.cls(BLOCK, 'remove-button'),
                                TestBem.cls(BLOCK, 'remove-button', { index: String(index) })
                            )}
                            size="s"
                            theme="clear"
                            onClick={this.onGroupRemove}
                        >
                            <Shape2 width={16} height={16} icon={Shape2Icon.trashbin} />
                        </Button>
                    )}
                </div>
            </div>
        );
    }

    private onGroupRemove = () => {
        const { index, onGroupRemove } = this.props;

        onGroupRemove(index);
    };

    private onPhrasesChange = (phrases: PhrasesSelectorGeneratorGroupPhrases) => {
        const { index, onPhrasesChange } = this.props;

        onPhrasesChange(index, phrases);
    };

    private onBlur = () => {
        const { index, phrases, onPhrasesChange } = this.props;

        onPhrasesChange(index, replaceDividerSymbols(phrases));
    };
}
